export const MonsterActionTypes = {
	MONSTER_LOADING_PENDING: 'MONSTER_LOADING_PENDING',
	MONSTER_LOADING_SUCCESS: 'MONSTER_LOADING_SUCCESS',
	MONSTER_LOADING_FAILED: 'MONSTER_LOADING_PENDING'	
};